<template>
    <AlertMessage type="danger">{{ $tm('general.invalidfieldsmessage') }}</AlertMessage>
</template>

<script lang="ts" setup>
import AlertMessage from './AlertMessage.vue';
</script>
